// IMPORTS
import baseIcon from "./baseIcon"

/**
 * Exporting "default" so that the import doesn't have to be named in other components.
 * To create named and/or multiple exports, use: export cont compName = {}
 * Remember to import any reactive features from 'vue' if you need reactivity (e.g. computed, ref, reactive, etc.)
 */
export default {
    /* Name the component for easy reference */
    name: 'IconCheckmark',

    /* Any imported component for this file needs to be listed here */
    components: {
        baseIcon
    },

    /* Declare any expected props here */
    props: {
        fill: {
            type: String,
            required: false,
            default: '#FFFFFF'
        }
    },

    /* All component logic goes here in setup(). Anything complex or verbose should be handled in an external file,
        using this as more of a "controller" for the component.
    */
    setup(props) {
        

        /* We need to return any variables/functions that we want to use in our template below. */
        return {
            props
        }
    },

    /* Define the template that will be displayed for this component (optional) */
    template: /*html*/`
        <div class="cfm_ec_icon cfm_ec_icon_checkmark">

            <base-icon
            :fill="props.fill"
            d="M5.48 10.089l1.583-1.464c1.854.896 3.028 1.578 5.11 3.063 3.916-4.442 6.503-6.696 11.311-9.688l.516 1.186c-3.965 3.46-6.87 7.314-11.051 14.814-2.579-3.038-4.301-4.974-7.469-7.911zm14.407.557c.067.443.113.893.113 1.354 0 4.962-4.038 9-9 9s-9-4.038-9-9 4.038-9 9-9c1.971 0 3.79.644 5.274 1.723.521-.446 1.052-.881 1.6-1.303-1.884-1.511-4.271-2.42-6.874-2.42-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11c0-1.179-.19-2.313-.534-3.378-.528.633-1.052 1.305-1.579 2.024z"
            ></base-icon>

        </div>
    `,
}